import { Link } from 'react-router-dom';
import { btnPrimario, btnSecundario, pesos, tarjeta } from '../../components/ui/estilos';
import { useCajaTurno } from './useCajaTurno';

const n = (v: any) => parseFloat(v || 0) || 0;
const dato = (label: string, valor: string) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 120 }}>
    <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.02em' }}>{label}</span>
    <span style={{ fontSize: 24, fontWeight: 700 }}>{valor}</span>
  </div>
);

// Turno de caja dentro de Inicio: lo del día a día (abrir, entradas/salidas, cerrar).
// El detalle completo (movimientos, propinas, cortes) sigue en /turno.
export default function TurnoPanel() {
  const t = useCajaTurno();
  const { turno, resumen } = t;

  if (t.cargando) return <section style={{ ...tarjeta, padding: 20, color: 'var(--muted)' }}>Cargando turno…</section>;

  return (
    <section aria-label="Turno de caja" style={{ ...tarjeta, padding: 20, display: 'flex', flexDirection: 'column', gap: 16 }}>
      {!turno ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16 }}>
          <div style={{ flex: '1 1 220px' }}>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>No hay turno abierto</h2>
            <div style={{ fontSize: 15, color: 'var(--muted)' }}>Cuenta el efectivo con el que arrancas la caja.</div>
          </div>
          <button onClick={() => t.setDialogo('abrir')} style={{ ...btnPrimario, height: 52, fontSize: 17 }}>Abrir turno</button>
          <button onClick={() => t.setDialogo('cajon')} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 15, fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}>Abrir cajón</button>
        </div>
      ) : <>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: '14px 32px' }}>
          {/* Ventas y tickets ya salen abajo en el resumen: aquí solo lo propio de la caja. */}
          {dato('Efectivo en caja', pesos(t.efectivoEsperado))}
          {dato('Propinas del turno', pesos(n(resumen?.total_propinas)))}
          {/* El estado del turno ya está arriba (chip "Turno abierto"); el enlace va en la misma fila. */}
          <div style={{ flex: 1 }} />
          <Link to="/turno" style={{ fontSize: 15, fontWeight: 700, color: 'var(--brand-texto)', textDecoration: 'none' }}>Ver detalle del turno →</Link>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          <button onClick={() => t.setDialogo('entrada')} style={btnSecundario}>+ Entrada de efectivo</button>
          <button onClick={() => t.setDialogo('salida')} style={btnSecundario}>− Salida de efectivo</button>
          <div style={{ flex: 1 }} />
          <button onClick={() => t.setDialogo('confirmar_cierre')} style={{ ...btnPrimario, height: 48, fontSize: 16 }}>Cerrar turno</button>
        </div>
      </>}
      {t.elementos}
    </section>
  );
}
